import React from 'react';
import { connect } from 'react-redux';
import { Button, Alert } from 'antd';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Input from '../../components/form/Input';
import Checkbox from '../../components/form/Checkbox';
import { required } from '../../components/form/validation';
import * as actions from './actions';

import s from './style.less';

class Login extends React.Component {
  static defaultProps = {
    error: '',
  };

  componentWillMount() {
    this.props.redirectIfLoggedIn();
  }

  submit = async values => {
    try {
      await this.props.login(values);
    } catch (e) {
      throw new SubmissionError({
        _error: e.error,
      });
    }
  };
  render() {
    return (
      <form onSubmit={this.props.handleSubmit(this.submit)}>
        <h1 className={s.h1}>Log In</h1>
        <div className={s.form}>
          <div>
            <h3 className={s.center}>
              <i>Log in using your email and password</i>
            </h3>
            <div className={s.fields}>All fields are required!</div>
            <Field
              placeholder="E-mail address"
              name="email"
              component={Input}
              type="email"
              validate={required}
            />
            <div className={s.margin} />
            <Field
              placeholder="Password"
              name="password"
              type="password"
              component={Input}
              validate={required}
            />
            <div className={s.flex}>
              <Field name="remember" component={Checkbox} label="Remember me" />
              <span className={s.forgot}>
                <Link to="/forgot-password">Forgot password?</Link>
              </span>
            </div>
            <Button htmlType="submit" type="primary">
              Log In
            </Button>
            <br />
            <br />
            {this.props.error && (
              <Alert message={this.props.error} type="error" />
            )}
          </div>
        </div>
      </form>
    );
  }
}

Login.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  login: PropTypes.func.isRequired,
  redirectIfLoggedIn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  initialValues: {
    remember: true,
  },
  userRole: state.user.role,
});

const mapDispatchToProps = dispatch => ({
  login: values => dispatch(actions.login(values)),
  redirectIfLoggedIn: () => dispatch(actions.redirectIfLoggedIn()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'login',
  })(Login),
);
